import { ProbateFilingSchema } from './toolkit';
import scheduleDa from './schedule-da-post-deceased-distributee';
import petitionForProbate from './petition-for-probate';
import familyTree from './family-tree';
import reportNotFullyDistributed from './report-not-fully-distributed';
import ss4EinApplication from './ss4-ein-application';
import form1310Refund from './form-1310-refund';
import scheduleDSecuredCreditors from './schedule-d-secured-creditors';
import firearmsInventory from './firearms-inventory';
import inventoryOfAssets from './inventory-of-assets';
import compulsoryAccountingPetition from './compulsory-accounting-petition';
import judicialSettlementPetition from './judicial-settlement-petition';
import wrongfulDeathPetitionWd2 from './wrongful-death-petition-wd2';

/** Reviewed catalogues, one per supported court PDF. */
export const PROBATE_FILING_SCHEMAS: ProbateFilingSchema[] = [
  scheduleDa,
  petitionForProbate,
  familyTree,
  reportNotFullyDistributed,
  ss4EinApplication,
  form1310Refund,
  scheduleDSecuredCreditors,
  firearmsInventory,
  inventoryOfAssets,
  compulsoryAccountingPetition,
  judicialSettlementPetition,
  wrongfulDeathPetitionWd2,
];
